import { clientFetch } from '~/lib/.client/fetch';
import { projectStore } from '~/lib/stores/project';
import { featurePreviewsStore } from '~/lib/stores/settings';
import { themeStore } from '~/lib/stores/theme';
import { userStore } from '~/lib/stores/user';
import { AnalyticsAction, type AnalyticsEvent, type BaseEventProperties } from '~/types/analytics';
import { logger } from '~/utils/logger';

// send an analytics event from the client
export async function sendAnalyticsEvent(event: AnalyticsEvent) {
  // don't send analytics events when in dev mode
  if (import.meta.env.DEV) {
    return;
  }

  if (event.action === AnalyticsAction.Page) {
    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search));

    const campaign = {
      content: queryParams.utm_content,
      name: queryParams.utm_campaign,
      medium: queryParams.utm_medium,
      source: queryParams.utm_source,
      keyword: queryParams.utm_term,
    };

    event.payload.properties = {
      ...event.payload.properties,
      url: window.location.href,
      path: window.location.pathname,
      search: window.location.search,
      referrer: window.document.referrer,
      title: window.document.title,
      theme: themeStore.get(),
    };

    event.payload.context = {
      ...event.payload.context,
      campaign,
      userAgent: navigator.userAgent,
      userAgentData: (navigator as any).userAgentData,
    };
  }

  if (event.action !== AnalyticsAction.Identify) {
    event.payload.properties = {
      ...event.payload.properties,
      featurePreviews: featurePreviewsStore.get(),
      projectId: projectStore.getProjectId(),
      orgId: userStore.getActiveOrganization().get()?.id,
      clientRevision: __COMMIT_HASH__,
    } as BaseEventProperties;
  }

  const response = await clientFetch('/api/analytics', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    keepalive: true,
    body: JSON.stringify(event),
  });

  if (!response.ok) {
    logger.error(`Error handling Segment Analytics action: ${event.action}`);
  }
}
